import React, { Component } from "react"
import { App } from "../../../App"
import { connect } from "react-redux"
import { AppState } from "../../../store"
import { UserInfo } from "../../../services/account/account-rest-interface"
import { setPriority } from "../../../stores/lesson.store"
import { getPracticeTestDetailsByTestId, isSatTest } from "../../../services/utils/practice-test-util"
import { RouteComponentProps } from "react-router-dom"
import WorkflowSAT from "./SAT/WorkflowSAT"
import "./VirtualPracticeTest.css"
import WorkflowACT from "./ACT/WorkflowACT"

const mapStateToProps = ({ account }: AppState) => ({
    userInfo: account.userInfo as UserInfo,
})

const mapDispatchToProps = { setPriority }

export interface StoreProps {
    userInfo: UserInfo
}

interface Props {

}

interface State {
    shouldRestoreNavbar: boolean
    testDetails: any
}

type AllProps = Props & StoreProps & RouteComponentProps<any>

/**
 * Both SAT and ACT computer-based virtual tests will require the use of a desktop or tablet device (mobile phones are not allowed).
 * In both cases, the test will occupy the entire browser screen for the duration of the exam.
 * 
 * Currently we are only handling SAT Practice Tests. Later we will prepare ACT Practice Tests as well.
 */
export class VirtualPracticeTestContainerView extends Component<AllProps, State> {
    constructor(props)  {
        super(props)

        this.state = {
            shouldRestoreNavbar: false,
            testDetails: undefined,
        }
    }

    async componentDidMount() {
        try {
            let { practiceId } = this.props.match.params
            let testDetails = await getPracticeTestDetailsByTestId(practiceId)
            let newState: any = { testDetails }
            if (!App.isNavbarCollapsed()) {
                App.collapseNavbar()
                newState.shouldRestoreNavbar = true
            }
            this.setState(newState)
            App.hideNavbar()
        }
        catch (err) {
            console.error("Failed to load the test details!")
        }
    }

    componentWillUnmount() {
        if (this.state.shouldRestoreNavbar) {
            if (App.isNavbarCollapsed()) {
                App.collapseNavbar(false)
            }
        }
        App.hideNavbar(false)
    }

    handleTestExit = (testName: string) => {
        let {props} = this as any
        props.history.goBack()
    }

    render() {
        let props: any = this.props
        let practiceId = props.match.params.practiceId
        let testTitle = practiceId
        let isSAT = isSatTest(practiceId)

        if (practiceId === "DiagnosticSAT") {
            testTitle = "SAT Diagnostic"
        }

        let {userInfo} = props
        let {testDetails} = this.state

        if (!testDetails) return null

        return (
            <div className="virtual-practice-test-container">
                {isSAT ?
                    <WorkflowSAT userInfo={userInfo} testDetails={testDetails} onTestExit={this.handleTestExit} />
                    :
                    <WorkflowACT userInfo={userInfo} testDetails={testDetails} onTestExit={this.handleTestExit} />
                }
            </div>
        )
    }
}

const VirtualPracticeTestContainer = connect<StoreProps, {}, {}, AppState>(mapStateToProps, mapDispatchToProps)(VirtualPracticeTestContainerView)

export default (props) => {
    return (
        <VirtualPracticeTestContainer {...props} />
    )
}
